import { OnInit, EventEmitter, TemplateRef, ElementRef, ChangeDetectorRef } from '@angular/core';
import { GalleryViewMode } from '../../models/gallery-view-mode.enum';
var GalleryContainerComponent = /** @class */ (function () {
    function GalleryContainerComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.viewMode = GalleryViewMode.Cards;
        this.checkedResults = [];
        this.loading = false;
        this.selectLabel = 'Select';
        this.checkable = true;
        this.showActions = true;
        this.selectBookmark = new EventEmitter();
    }
    Object.defineProperty(GalleryContainerComponent.prototype, "results", {
        get: function () {
            return this._results;
        },
        set: function (value) {
            this._results = value;
            this.changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    GalleryContainerComponent.prototype.ngOnInit = function () {
    };
    GalleryContainerComponent.prototype.handleSelect = function (result) {
        this.selectBookmark.emit(result);
    };
    return GalleryContainerComponent;
}());
export { GalleryContainerComponent };
